const dayjs = require('dayjs')

async function ApiCall(url, data = undefined, method = 'GET', contentType="application/json") {
  const response = await fetch(`/api/${url}`, {
    method: method,
    headers: {
        'Content-Type': contentType
    },
    body: JSON.stringify(data)
  });

  try {
    response.data = await response.json();
  } catch { }

  return response;
}


export {
  ApiCall
}